import React from 'react';
import PropTypes from 'prop-types';
import styles from './InputFieldErrorMessage.module.scss';

const InputFieldErrorMessage = ({
  field,
  fieldHasCounter = false,
  noMargin = false,
}) => {
  const extraStyles = `${fieldHasCounter ? styles['error--with-counter'] : ''} ${noMargin ? styles['error--no-margin'] : ''}`;

  return (
    !!(field.touched && field.errors.length) && (
      <p
        name="input-field-error"
        // The non-styles error class is used by our scroll-to-error mechanism
        className={`error ${styles.error} ${extraStyles}`}
      >
        {field.errors[0]}
      </p>
    )
  );
};

InputFieldErrorMessage.propTypes = {
  field: PropTypes.shape({
    touched: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  fieldHasCounter: PropTypes.bool,
  noMargin: PropTypes.bool,
};

export default InputFieldErrorMessage;
